"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var yup = __importStar(require("yup"));
exports.loginSchema = function () {
    return yup.object({
        login: yup
            .string()
            .min(3)
            .max(320)
            .required(),
        password: yup
            .string()
            .min(8)
            .max(64)
            .required()
    });
};
//# sourceMappingURL=auth.js.map